import { AppAudioPlayer } from './AppAudioPlayer';
import { IRefObject } from '@uifabric/utilities';

export enum AppAudioPlayerFeatureName {
  // Maintain the alphabetical order, while adding new features.
  PauseAudio = 'PauseAudio',
  PlayAudio = 'PlayAudio',
  PlaybackSpeedChange = 'PlaybackSpeedChange',
  SeekBackward = 'SeekBackward',
  SeekForward = 'SeekForward',
  ShowVolume = 'ShowVolume',
  VolumeChange = 'VolumeChange'
}

export interface IAudioPlayer {
  /**
   * Allows to seek to a specific time (seconds) in the audio
   */
  seekTime: (time: number) => void;

  /**
   * Get current playback speed of the audio player
   */
  getPlayBackSpeed: () => number;

  /**
   * Get current Seek time of the audio player
   */
   getCurrentAudioTime: () => number;
}

export interface AppAudioPlayerProps extends React.ClassAttributes<AppAudioPlayer> {
  type: 'AppAudioPlayerProps';

  /**
   * Defines the source url for the audio
   */
  audioSrc: string;

  /**
   * An optional title, user can choose to display on top of the audio player
   */
  audioPlayerTitle?: string;

  /**
   * Set an optional link to convert the audio player title from a label to a link
   */
  audioPlayerTitleLink?: string;

  /**
   * Ref object that gives tha parent access to the audio player
   */
  componentRef?: IRefObject<IAudioPlayer>;

  /**
   * Forward and backward rate (seconds).
   */
  seekJump?: number;

  /**
   * Callback called when the audio control is loaded
   */
  onAudioControlLoaded?: (duration: number) => void;

  /**
   * Callback called when the audio position is updated
   */
  onAudioPositionUpdated?: (audioPosition: number) => void;

  /**
   * Callback called when user interacts with controls of AppAudioPlayer components
   */
  onUserInteraction?: (feature: AppAudioPlayerFeatureName, timestamp : number, playbackSpeed : number) => void;
}
